import React, { useEffect } from 'react';
import styles from "../css/Exhibition.module.css";
import { KeyboardBackspace } from '@mui/icons-material';
import Box from "components/inputs/Box";
import Button from "components/inputs/Button";
import Loading from "components/layout/Loading";
import ExhibitionForm from "components/form/ExhibitionForm";

import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { resetCreateExhibition } from "service/util/resetCreateExhibition";

import ExhibitionService from "service/apiConfig/ExhibitionService";
import { exhibitionActions } from "reducers/exhibition";
import { commonActions } from "reducers/common";
import {exhibitionServerValidation} from "../../service/validation/exhibitionServerValidation";

const ExhibitionEdit = () => {
    const history = useHistory();
    const params = useParams();
    const dispatch = useDispatch();
    const type = useSelector(state => state.exhibitionData.type);
    const exhibitionRoom = useSelector(state => state.exhibitionData.exhibitionRoom);
    const subTopicList = useSelector(state => state.exhibitionData.subTopicList);
    const exhibitionImageFile = useSelector(state => state.exhibitionData.exhibitionImageFile);
    const isLoading = useSelector(state => state.commonData.isLoading);

    useEffect(() => {
        dispatch(commonActions.trueIsLoading());
        ExhibitionService.getById(params.id)
            .then(response => {
                dispatch(exhibitionActions.setExhibitionRoom(response.data.data.exhibitionRoom));
                dispatch(exhibitionActions.setSubTopicList(response.data.data.roomSubTopicList));
                dispatch(commonActions.falseIsLoading());
            })
            .catch(err => console.log(err));
    }, [dispatch, params.id])

    const onSubmitUpdateExhibition = (e) => {
        e.preventDefault();
        const formData = new FormData();
        const exhibitionRoomData = {
            "id": exhibitionRoom.id,
            "seq": exhibitionRoom.seq,
            "roomNo":exhibitionRoom.roomNo,
            "name": exhibitionRoom.name,
            "introduction": exhibitionRoom.introduction,
            "imageUrl": exhibitionRoom.imageUrl !== null ? exhibitionRoom.imageUrl : null ,
            "imageAltText": exhibitionRoom.imageAltText,
            "invalid":  exhibitionRoom.invalid,
            "commentator" :{ "id" : exhibitionRoom.commentator.id },
            "commentatorForKid" : type === 'kor' ? { "id" : exhibitionRoom?.commentatorForKid?.id ? exhibitionRoom.commentatorForKid.id : null } : null,
            "commentatorForBlind" : type === 'kor' ? { "id" : exhibitionRoom?.commentatorForBlind?.id ? exhibitionRoom.commentatorForBlind.id : null } : null,
            "language" : { "id": type === 'kor' ? 1 : 2 },
            "parentId" : type === 'eng' ? exhibitionRoom.parentId : null
        }

        formData.append('exhibitionRoom', JSON.stringify(exhibitionRoomData));
        formData.append('roomSubTopicList', JSON.stringify(subTopicList));
        formData.append('file', exhibitionImageFile);

        ExhibitionService.create(formData)
            .then(response => {
                exhibitionServerValidation(response, history, dispatch, type);
                dispatch(exhibitionActions.setSubTopic({}));
            })
            .catch(err => console.log(err));
    }

    const handleGoBack = (e) => {
        e.preventDefault();
        resetCreateExhibition(dispatch, type);
        history.goBack();
    }
    return (
        <>
        {isLoading && <Loading />}
        <section className={`sectionWrap ${styles.exhibitionWrap}`}>
            <header>
                <h2>전시 수정</h2>
                <button onClick={(e) => handleGoBack(e)}><KeyboardBackspace /></button>
            </header>
            <Box>
                {exhibitionRoom &&
                    <ExhibitionForm edit={true} />
                }
                <Button onClick={onSubmitUpdateExhibition} style={{ background: "#a2b521", display: "flex", marginLeft: "auto" }}>수정</Button>
            </Box>
        </section>
        </>
    );
};

export default ExhibitionEdit;